import React from 'react';

const ProductDescriptionTab = ({ selected, data }) => {
  if (!data) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`} dangerouslySetInnerHTML={{ __html: data.data }} />
  );
};

export default ProductDescriptionTab;
